export default "__VITE_ASSET__405c11ef__"